export const CONTRACT_GET_DATA_ERROR = 'Querying data from contract failed.';
export const MANAGER_FORWARD_CALL = 'ManagerForwardCall';
export var CONTRACT_METHOD_NAME;
(function (CONTRACT_METHOD_NAME) {
    CONTRACT_METHOD_NAME["Transfer"] = "Transfer";
    CONTRACT_METHOD_NAME["GetBalance"] = "GetBalance";
    CONTRACT_METHOD_NAME["TransferToken"] = "TransferToken";
    CONTRACT_METHOD_NAME["GetAllowance"] = "GetAllowance";
    CONTRACT_METHOD_NAME["GetTokenInfo"] = "GetTokenInfo";
    CONTRACT_METHOD_NAME["Approve"] = "Approve";
})(CONTRACT_METHOD_NAME || (CONTRACT_METHOD_NAME = {}));
